import { render, staticRenderFns } from "./ImportExportPresets.vue?vue&type=template&id=4ad4df72&"
import script from "./ImportExportPresets.vue?vue&type=script&lang=ts&"
export * from "./ImportExportPresets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports